import { useSettings } from '../contexts/SettingsContext';

/**
 * Custom hook to get the dynamic currency symbol from settings
 * @returns Currency symbol from settings or default '₨'
 */
export const useCurrency = () => {
  const { getSetting } = useSettings();
  
  const getCurrencySymbol = () => {
    return getSetting('currency_symbol') || '₨';
  };
  
  const formatCurrency = (amount: number | string | undefined | null): string => {
    if (amount === undefined || amount === null) {
      return `${getCurrencySymbol()}0`;
    }
    
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    
    if (isNaN(numAmount)) {
      return `${getCurrencySymbol()}0`;
    }
    
    return `${getCurrencySymbol()}${numAmount.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    })}`;
  };
  
  const formatCurrencyWithDecimals = (amount: number | string | undefined | null): string => {
    if (amount === undefined || amount === null) {
      return `${getCurrencySymbol()}0.00`;
    }
    
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    
    if (isNaN(numAmount)) {
      return `${getCurrencySymbol()}0.00`;
    }
    
    return `${getCurrencySymbol()}${numAmount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };
  
  return {
    currencySymbol: getCurrencySymbol(),
    formatCurrency,
    formatCurrencyWithDecimals
  };
};